import { REDIRECT_TO_HOME, REDIRECT_TO_LOGIN } from './errors';
import { getPostLogoutRedirect } from '../util/logoutRedirect';
import { clearLocalStoragePreservingOnboarding } from '../util/preserveOnboardingStorage';
// import { useNavigation } from "@react-navigation/native";

function useRedirectErrors() {
    // const {
    //     context: { setClientError }
    // } = React.useContext(AuthContext);

    const signOut = async () => {
        if (typeof window !== 'undefined') {
            window.__logoutInProgress = true;
        }
        clearLocalStoragePreservingOnboarding();
        window.location.replace(getPostLogoutRedirect() || '/login');
    };

    // const showClientError = (error) => {
    //     setClientError(error.graphQLErrors)
    // }

    const passingErrors = async (error, navigate) => {
        // const navigation = useNavigation();
        console.log('useRedirectErrors: ', error);
        // console.log('incoming error', error.graphQLErrors.e);
        if (Array.isArray(error.graphQLErrors)) {
            if (error.graphQLErrors.length > 0) {
                error.graphQLErrors.forEach(async error => {
                    console.log('incoming errors', error);
                    // Safety check: ensure extensions exists before accessing code
                    const errorCode = error?.extensions?.code;
                    console.log('incoming errors', errorCode);
                    console.log('incoming errorssss', errorCode === REDIRECT_TO_LOGIN);
                    if (errorCode === REDIRECT_TO_HOME) {
                        // do something
                    } else if (errorCode === REDIRECT_TO_LOGIN) {
                        signOut();
                        // await AsyncStorage.removeItem("userData");
                        // navigate("SignIn");
                        // navigation.navigate("SignIn")
                    } else {
                        // history.push('/login');
                        // showClientError(error);
                    }
                });
            } else {
                if (error.message && error.message.includes('Network error: Failed to fetch')) {
                    window.location.replace('/error');
                }
            }
        } else if (error.graphQLErrors) {
            // Handle non-array graphQLErrors
            const errorCode = error.graphQLErrors?.extensions?.code || error.graphQLErrors?.code;
            if (errorCode === REDIRECT_TO_HOME) {
                // do something
            } else if (errorCode === REDIRECT_TO_LOGIN) {
                signOut();
                // await AsyncStorage.removeItem("userData");
                // navigate("SignIn");
                // navigation.navigate("SignIn")
            } else {
                // signOut();
                // history.push('/login');
                // showClientError(error);
            }
        } else {
            // Handle subscription errors or other error types that don't have graphQLErrors
            // Just log the error - subscription errors are handled in the component
            console.warn('Error without graphQLErrors structure:', error);
        }
    };

    return { passingErrors };
}

export default useRedirectErrors;
